module.exports = "<div [ngClass]=\"'panels-wells'\">\r\n  <div class=\"panel panel-primary\">\r\n    <div class=\"panel-heading bg-primary\">\r\n      {{heading}}\r\n    </div>\r\n    <div class=\"panel-body\">\r\n      <p>{{body}}</p>\r\n    </div>\r\n    <div class=\"panel-footer text-primary\">\r\n      {{footer}}\r\n    </div>\r\n  </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/panels-wells/panels-wells.component.html
// module id = ./src/app/shared/components/panels-wells/panels-wells.component.html
// module chunks = main